import React from 'react';

export const FullScreenSpaLoader = () => (
  <div id="spa-loader">
    <div id="spa-loader-svg"></div>
  </div>
);
